import EAdResult from '~~/search/common/vue/components/results/ad';
import EWebResult from '~~/search/common/vue/components/results/web';
import EVideosSnippet from '~/components/snippets/videos';
import ENewsSnippet from '~/components/snippets/news';
import { MAINLINE, SIDEBAR } from './position';
import importComponents from './import-components';
import mainlineMap from './maps/mainline.json';
import sidebarMap from './maps/sidebar.json';

const baseComponentsMap = {
  ad: EAdResult,
  web: EWebResult,
  videosSnippet: EVideosSnippet,
  newsSnippet: ENewsSnippet,
};

const componentMaps = {
  [MAINLINE]: { ...baseComponentsMap, ...importComponents(mainlineMap) },
  [SIDEBAR]: { ...baseComponentsMap, ...importComponents(sidebarMap) },
};

/**
 * Finds appropriate components for every result based on its position.
 * Skips any results with no associated components.
 *
 * @param {Iterable} results
 * @param {String} position `mainline` or `sidebar`
 * @returns {Iterator}
 */
export default function* withComponents(results, position = MAINLINE) {
  for (const result of results) {
    if (!result || !result.type) {
      continue;
    }

    const component = componentMaps[position]?.[result?.type];
    if (!component) {
      continue;
    }

    yield { result: { ...result, pagePosition: position }, component };
  }
}
